import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    throwError as observableThrowError,
    Observable,
    BehaviorSubject,
    throwError,
} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Response } from '@angular/http';
@Injectable({
    providedIn: 'root',
})
export class FundingService {
    Url = 'https://auth.chakaent.com/api/v1';
    constructor(
        private http: HttpClient,
        @Inject('baseUrl') private baseUrl: string
    ) {}

    //fetch all questions by channels
    channels() {
        return this.http
            .get(this.baseUrl + `/channels?pageNumber=0&pageSize=10`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    //fetch all questions by channels
    rate() {
        return this.http
            .get(this.baseUrl + `/rates/today`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }
    //fetch payment reference
    PaymentGeneratePayRef(processor: string, source: string) {
        const body = {
            processor: processor,
            source: source,
        };
        return this.http
            .post(this.baseUrl + `/payments/generatepayref`, body)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    //fetch payment reference
    confirmPayment(
        amount: any,
        currency: string,
        source: string,
        transactionReference: string,
        status: any,
        statusCode: string,
        productType: string
    ) {
        const body = {
            amount: amount,
            currency: currency,
            source: source,
            transactionReference: transactionReference,
            status: status,
            statusCode: statusCode,
            productType:productType
        };
        return this.http
            .post(this.baseUrl + `/payments/confirm`, body)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    //fetch users information
    UserInformation() {
        return this.http
            .get(this.Url + `/users/me`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    // check user profile
    getProfile() {
        return this.http
            .get(this.baseUrl + `/users/profile`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    //getWithdrawal
    CreateRedemption(amount:number){
        const body ={
            amount:amount
        }
        return this.http
            .post(this.baseUrl + `/redemption`,body)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }


    changePassword(currentPassword:string, password:string){
        const body ={
            currentPassword:currentPassword,
            password:password
        }
        return this.http
            .post(this.Url + `/users/change-password`,body)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

}
